import config from "config";
import { Howl } from "howler";
import tools from "tools";
class AssetsLoader {
  constructor() {
    this._checkNameAvailability = this._checkNameAvailability.bind(this);
    this.load = this.load.bind(this);
    this.imgs = [];
    this.jsons = [];
    this.audio = [];
    this.assets = {};
    this.dataSize = 0;
    this.dataLoaded = 0;
    this.loadError = 0;
  }
  addEventListener(eventType, callback) {
    switch (eventType) {
      case "complete":
        this._completeCallback = callback;
        break;
      case "progress":
        this._progressCallback = callback;
        break;
      default:
        this._progressCallback = callback;
    }
  }
  removeEventListener(eventType) {
    switch (eventType) {
      case "complete":
        this._completeCallback = null;
        break;
      case "progress":
        this._progressCallback = null;
        break;
      default:
        this._progressCallback = null;
    }
  }
  add(data) {
    let ext = data.path.split(".").pop();
    switch (ext) {
      case "jpg":
      case "png":
        this.imgs.push(data);
        this.dataSize++;
        break;
      case "json":
        this.jsons.push(data);
        this.dataSize++;
        break;
      case "mp3":
        this.audio.push(data);
        this.dataSize++;
        break;
      case "glb":
        break;
      default:
        break;
    }
  }
  load() {
    this._process();
    this.isAllAssetsLoaded = setInterval(() => {
      const percent = this.dataLoaded / this.dataSize;
      this._progressCallback && this._progressCallback({
        type: "progress",
        percent: percent
      });
      if (percent >= 1) {
        this.isAllAssetsLoaded && clearInterval(this.isAllAssetsLoaded);
        this._completeCallback && this._completeCallback({
          type: "complete",
          assets: this.assets
        });
      }
    }, 100);
  }
  reset() {
    this.assets = {};
    this.dataSize = 0;
    this.dataLoaded = 0;
    this.loadError = 0;
    this.imgs = [];
    this.jsons = [];
    this.audio = [];
  }
  _process() {
    this._loadImgs();
    this._loadJson();
    this._loadAudio();
  }
  _loadImgs() {
    let img;
    for (let i = 0; i < this.imgs.length; i++) {
      img = this._getElementNS("img");
      img.crossOrigin = "anonymous";
      img._name = this.imgs[i].name;
      img._path = this.imgs[i].path;
      img.addEventListener('load', e => {
        this._checkNameAvailability(e.target._name, e.target);
      }, false);
      img.addEventListener('error', e => {
        this.loadError++;
        this._incDataLoaded();
      }, false);
      img.src = this.imgs[i].path;
    }
  }
  _getElementNS(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
  }
  _loadAudio() {
    let _audio;
    let audio = this.audio;
    let dataLoaded = this._incDataLoaded;
    let checkNameAvailability = this._checkNameAvailability;
    let allSoundsToLoad = audio.length;
    let soundLoaded = 0;
    let soundTime = new Date().getTime();
    for (let i = 0; i < audio.length; i++) {
      _audio = new Howl({
        src: [audio[i].path],
        sprite: audio[i].audioSprite,
        onload: function () {
          checkNameAvailability(this._name, this);
          soundLoaded++;
          if (soundLoaded >= allSoundsToLoad) {
            // config.sdk.getAnalyticsModule().onCustomEvent("inGame_soundTimeInMs", soundTime);
            soundTime = tools.timeToSec(new Date().getTime() - soundTime);
            config.sdk.getAnalyticsModule().onCustomEvent("inGame_soundTime", soundTime);
          }
        },
        onloaderror: function () {
          this.loadError++;
          dataLoaded();
        }
      });
      _audio._name = audio[i].name;
      config.AllAudios.push(_audio);
    }
  }
  async _loadJson() {
    for (let i = 0; i < this.jsons.length; i++) {
      try {
        const data = await (await fetch(this.jsons[i].path)).json();
        this._checkNameAvailability(this.jsons[i].name, data);
      } catch (error) {
        this.loadError++;
        this._incDataLoaded();
      }
    }
  }
  _incDataLoaded = () => {
    this.dataLoaded++;
  };
  _checkNameAvailability(name, data) {
    if (!this.assets[name]) {
      this.assets[name] = data;
    }
    this._incDataLoaded();
  }
  get loadError() {
    return this._loadError;
  }
  set loadError(val) {
    this._loadError = val;
  }
}
export default new AssetsLoader();
